import { api } from '@here/api'
import type { SetupFilter } from '../filter'
import type { Pagination } from '../index'

export const handleGetPublished = async ({
	filters,
	pagination,
}: { filters: SetupFilter; pagination: Pagination }) => {
	let query: any

	if (filters.sort === 'recent-activity') {
		query = api().from('setup').select('*').eq('status', 'published').order('updated_at', { ascending: false })
	}

	if (filters.sort === 'recently-submitted') {
		query = api().from('setup').select('*').eq('status', 'published').order('created_at', { ascending: false })
	}

	if (filters.sort === 'takers') {
		query = api()
			.from('setup_with_taken_counts')
			.select('*')
			.order('count', { ascending: false })
	}

	if (filters.sort === 'subscribers') {
		query = api()
			.from('most_subscribed_setups')
			.select('*')
			.order('count', { ascending: false })
    }

    if (filters.sort === 'community-score') {
      query = api()
			.from('setup_with_community_score')
			.select('*')
      .order('community_score', { ascending: false })

    }

    if (filters.sort === 'PHQ') {
      query = api()
			.from('setup_with_commander_score')
			.select('*')
      .order('commander_score', { ascending: false })
	}

	// let query =
	// 	filters.sort === 'default'
	// 		? api().from('setup').select('*').eq('status', 'published')
	// 		: filters.sort === 'takers'
	// ? api()
	// 		.from('setup_with_taken_counts')
	// 		.select('*')
	// 		.order('count', { ascending: false })
	// : api()
	// 		.from('most_subscribed_setups')
	// 		.select('*')
	// 		.order('count', { ascending: false })

	// Apply filters
	if (filters.duration.length) query = query.in('duration', filters.duration)
	if (filters.symbols.length) query = query.in('symbol', filters.symbols)
	if (filters.assetType.length) query = query.in('market', filters.assetType)
	if (filters.patternSpecification.length)
		query = query.in('pattern_specification', filters.patternSpecification)
	if (filters.position.length) query = query.in('position', filters.position)
	if (filters.stage.length) query = query.in('stage', filters.stage)

	// Ordering
	// if (filters.source === 'default') {
	// 	for (const [field, ascending] of Object.entries(filters.order)) {
	// 		if (ascending !== undefined) {
	// 			query = query.order(field, { ascending })
	// 		}
	// 	}
	// }

	// Apply limit + offset
	if (pagination.limit !== undefined && pagination.offset !== undefined) {
		query = query.range(pagination.offset, pagination.offset + pagination.limit - 1)
	}

	const { data } = await query
	return data || []
}
